import {RightWithPositionsAndUsers} from "../../types/api/authorization/right.types";
import {rightService} from "../../services/authorization/right-service";
import {useFetch} from "../useFetch";

export const useFetchAllRights = () => {
    const {data, isLoading, error, refetch} = useFetch<RightWithPositionsAndUsers[]>(rightService.getAll);

    return {data: data || [], isLoading, error, refetch};
}